/**
 * createDocumentState
 *
 * Pure Valtio state for a single document.
 */

import { proxy } from 'valtio';
import type { DocumentState } from '../Store.types';

/**
 * Creates a Valtio reactive state for a single document.
 */
export function createDocumentState<
  T extends Record<string, unknown>,
>(): DocumentState<T> {
  return proxy<DocumentState<T>>({
    loading: true,
    data: null,
    error: null,
  });
}
